import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  gs,
  useMsgz,
  BoxC,
  GridC,
  IptC,
  LblC,
  SrlC,
  _cv_31___Mz,
  _cv_70___Ci,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import { useMsgz } from "./_csMdlMsg";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_70___Ci from "./_cv_70___Ci";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icm from './icm';

import * as icvI18___Mz from './icvI18___Mz';

let $_31rs = [] as ht.ls;

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _sMsgz = useMsgz();

  React.useEffect(() => {
    _cv_31___Mz.load_31rLsAsync()
    .then((_ls: ht.ls) => {
      //hf.l(`icv_70S10Co 32: ${hf.s(_ls)}`);
      $_31rs = _ls.concat([{ key: 0, pfx: 'すべての団体'}]);
      pz.sPz.udtAll();
    });
  }, [
  ])

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                ]
              },
              {
                oClds: [
/*
                  cr.c(LblC.N, {
                    key: -10,
                    abtType: 'ftnCmnz',
                    boxStlz: a('dw/23'),
                    lblCz: {
                      boxStlz: a('dw/8'),
                      textz: {
                        pfx: '変更履歴',
                      }
                    },
                    cttCz: {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          abtType: 'ftnCmnz',
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: [],
                          },
                        })
                      ]
                    },
                  })
*/
                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',          
          oClds: [

            cr.c(SrlC.V, {
              key: -10,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(_cv_70___Ci.D, {
                  key: -20,
                  sPz: pz.sPz,
                  cz: {
                    _70ra1100js: $_31rs,
                  }
                }),


              ],
            }),

            cr.c(_cv_70___Ci.B, {
              key: -40,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn',
                grtMailsAsync: async (_70z: ht.dz) => {
                  const _b = await hf.ectSrlAsync([
                    async () => {
                      let _b = true;
                      if (
                        !(hf.j(_70z._70rz._70ra1100j)?.key > 0)
                      ) {
                        _b = false;
                        _sMsgz.show({
                          textCz: {
                            textz: {
                              pfx: '宛先を入力ください',
                            }
                          }
                        })
                      }
//hf.l(`icv_70S10Co 142: ${_b}`);
                      return _b;
                    },
                    async () => {
                      let _b = true;
                      if (
                        !hf.f(_70z._70rz._pfx)
                      ) {
                        _b = false;
                        _sMsgz.show({
                          textCz: {
                            textz: {
                              pfx: '件名を入力ください',
                            }
                          }
                        })
                      }
//hf.l(`icv_70S10Co 142: ${_b}`);
                      return _b;
                    },
                    async () => {
                      let _b = true;
                      if (
                        !hf.f(_70z._70rz._70ra2100t)
                      ) {
                        _b = false;
                        _sMsgz.show({
                          textCz: {
                            textz: {
                              pfx: '内容を入力ください',
                            }
                          }
                        })
                      }
//hf.l(`icv_70S10Co 142: ${_b}`);
                      return _b;
                    },
                  ]);
                  if (_b) {
//                  if (false) {
                    const _gUserz = gs.useUserz();
                    const _mails = [] as ht.ls;
                    const _31r_fst = hf.j(_70z._70rz._70ra1100j).key;
                    const _i18rs = await icvI18___Mz.loadI18rLsAsync({
                      _31r_fst: _31r_fst > 0 ? _31r_fst : undefined,
                      cdn: 'true',
                    });
                    _i18rs.map((_i18rz: ht.dz) => {
                      const _mailz = icm.gasMailAsync({
                        i18r_fst: _i18rz._fst,
                        _31r_fst: _gUserz.crt._31rz._fst,
                        sjt: _70z._70rz._pfx,
                        msg: _70z._70rz._70ra2100t,
                      });
                      _mails.push(_mailz);
                    })
                    return _mails;
                  }
                  else {
                    return undefined;
                  };
                }
              }
            })

          ]
        })

      ]
    })
  );
};

